import React from "react";
import { FaChartLine, FaHome, FaUser } from "react-icons/fa";
import {
  MdOutlineReport,
  MdLocalOffer,
  MdAccountBalanceWallet,
  MdPayments,
  MdPointOfSale,
  MdEditNote,
  MdInventory2,
  MdPayment,
  MdAccountBalance,
  MdMoneyOff,
  MdOutlineHandshake,
  MdStore,
  MdBusiness,
  MdCategory,
} from "react-icons/md";
import { GrTransaction } from "react-icons/gr";
import { TbCash } from "react-icons/tb";
import { BsCalendar2Day } from "react-icons/bs";

const iconClass = "text-[15px]";

export const buildSideMenuItems = (base, { includeReceivablesPayables = true } = {}) => {
  const items = [
    {
      title: "Counter Sale",
      icon: <MdPointOfSale className={iconClass} />,
      link: `${base}/customers-invoice`,
      section: "Daily",
    },
    {
      title: "Expense",
      icon: <MdMoneyOff className={iconClass} />,
      link: `${base}/expense`,
      section: "Daily",
    },
    {
      title: "Payments",
      icon: <MdPayment className={iconClass} />,
      link: `${base}/payments`,
      section: "Daily",
    },
    {
      title: "Ledgers",
      icon: <GrTransaction className={iconClass} />,
      link: `${base}/ledger`,
      section: "Daily",
    },
    {
      title: "Dashboard",
      icon: <FaHome className={iconClass} />,
      link: base,
      section: "Overview",
    },
    {
      title: "Daily Report",
      icon: <BsCalendar2Day className={iconClass} />,
      link: `${base}/daily-report`,
      section: "Overview",
    },
    {
      title: "Reports",
      icon: <MdOutlineReport className={iconClass} />,
      link: `${base}/report`,
      section: "Overview",
    },
    {
      title: "Edit Invoice",
      icon: <MdEditNote className={iconClass} />,
      link: `${base}/edit-customers-invoice`,
      section: "Sales",
    },
    {
      title: "Customers",
      icon: <FaUser className={iconClass} />,
      link: `${base}/customers`,
      section: "Sales",
    },
    {
      title: "Companies",
      icon: <MdBusiness className={iconClass} />,
      link: `${base}/companies`,
      section: "Inventory",
    },
    {
      title: "Items",
      icon: <MdCategory className={iconClass} />,
      link: `${base}/items`,
      section: "Inventory",
    },
    {
      title: "Stock & Invoices",
      icon: <MdInventory2 className={iconClass} />,
      link: `${base}/invoices`,
      section: "Inventory",
    },
  ];

  if (includeReceivablesPayables) {
    items.push(
      {
        title: "Receivables",
        icon: <MdAccountBalanceWallet className={iconClass} />,
        link: `${base}/receivables`,
        section: "Finance",
      },
      {
        title: "Payables",
        icon: <MdPayments className={iconClass} />,
        link: `${base}/payables`,
        section: "Finance",
      },
      {
        title: "Cash Payments",
        icon: <TbCash className={iconClass} />,
        link: `${base}/cash-payments`,
        section: "Finance",
      },
      {
        title: "Finance",
        icon: <FaChartLine className={iconClass} />,
        link: `${base}/finance`,
        section: "Finance",
      }
    );
  }

  items.push(
    {
      title: "Accounts",
      icon: <MdAccountBalance className={iconClass} />,
      link: `${base}/accounts`,
      section: "Finance",
    },
    {
      title: "Loans",
      icon: <MdOutlineHandshake className={iconClass} />,
      link: `${base}/loans`,
      section: "Finance",
    },
    {
      title: "Discount Log",
      icon: <MdLocalOffer className={iconClass} />,
      link: `${base}/discount-log`,
      section: "Records",
    },
    {
      title: "Stock Qty Log",
      icon: <MdInventory2 className={iconClass} />,
      link: `${base}/stock-qty-log`,
      section: "Records",
    }
  );

  if (base === "/admin") {
    items.push({
      title: "Loan portals",
      icon: <FaUser className={iconClass} />,
      link: `${base}/loan-accounts`,
      section: "Records",
    });
  }

  if (base === "/admin") {
    items.push({
      title: "Branches",
      icon: <MdStore className={iconClass} />,
      link: `${base}/branches`,
      section: "Admin",
    });
  }

  return items;
};

export const buildSuperAdminMenuItems = (base = "/admin") => [
  {
    title: "Dashboard",
    icon: <FaHome className={iconClass} />,
    link: base,
    section: "Overview",
  },
  {
    title: "Daily Report",
    icon: <BsCalendar2Day className={iconClass} />,
    link: `${base}/daily-report`,
    section: "Overview",
  },
  {
    title: "Reports",
    icon: <MdOutlineReport className={iconClass} />,
    link: `${base}/report`,
    section: "Overview",
  },
  {
    title: "Ledgers",
    icon: <GrTransaction className={iconClass} />,
    link: `${base}/ledger`,
    section: "Overview",
  },
  {
    title: "Receivables",
    icon: <MdAccountBalanceWallet className={iconClass} />,
    link: `${base}/receivables`,
    section: "Finance",
  },
  {
    title: "Payables",
    icon: <MdPayments className={iconClass} />,
    link: `${base}/payables`,
    section: "Finance",
  },
  {
    title: "Cash Payments",
    icon: <TbCash className={iconClass} />,
    link: `${base}/cash-payments`,
    section: "Finance",
  },
  {
    title: "Finance",
    icon: <FaChartLine className={iconClass} />,
    link: `${base}/finance`,
    section: "Finance",
  },
  {
    title: "Loans",
    icon: <MdOutlineHandshake className={iconClass} />,
    link: `${base}/loans`,
    section: "Finance",
  },
  {
    title: "Loan portals",
    icon: <FaUser className={iconClass} />,
    link: `${base}/loan-accounts`,
    section: "Finance",
  },
  {
    title: "Stock Qty Log",
    icon: <MdInventory2 className={iconClass} />,
    link: `${base}/stock-qty-log`,
    section: "Records",
  },
];

export const groupMenuItems = (items = []) => {
  const groups = [];
  const indexBySection = new Map();

  items.forEach((item) => {
    const section = item.section || "Menu";
    if (!indexBySection.has(section)) {
      indexBySection.set(section, groups.length);
      groups.push({ label: section, items: [] });
    }
    groups[indexBySection.get(section)].items.push(item);
  });

  return groups;
};

export const buildLoanAccountMenuItems = (base = "/loan-account") => [
  {
    title: "My loan",
    icon: <MdOutlineHandshake className={iconClass} />,
    link: base,
    section: "Loans",
  },
];
